<template>

<div align="justify">
    <!--<p class="h4" align="center">Сайт организации ООО "АИС"</p>-->
    <div align="justify" style="padding: 10px;">
        
        Работаем с 2008 года.<br>
        Сотрудничаем более чем с 70 фирмами на постоянной основе.<br>
        Дополнительно поступают обращения разового характера.<br>
        Основная сфера деятельность – разработка программного обеспечения.<br>
        Оказываем услуги:<br>
        - продажа, сопровождение (установка, обновление, консультация, доработка конфигураций) программных продуктов «1С» и совместных решений(«Трактиръ»)<br>
        - подключение к сервису «1С: Фреш», консультация, разработка расширений для конфигураций 1С, разработка внешних отчётов и обработок.<br>
        - подключение к системам, проведение консультаций: Меркурий (работа с ветеринарными сертификатами), ЕГАИС (работа с алкоголем),Честный знак (работа с маркировкой)<br>
        - услуги удостоверяющего центра и электронные торги (выдача ЭП на физ.лица для любого назначения, консультации)<br>
        - онлаин-кассы - продажа, ремонт, модернизация, подключение к ОФД, регистрация и обслуживание<br>
        - отправка электронной отчетности и электронный документооборот (консультация и помощь при подключении к операторам ЭДО, помощь в работе с документами)<br>
        - автоматизация торговли: консультации по подбору торгового оборудования и ПО, продажа, установка и настройка программных решений 1С для торговли (например, "1С: Розница 3.0", "1С: Управление нашей фирмой", "1С: Управление торговлей"), подключение и настройка торгового оборудования (сканеры штрих-кодов, ККТ, эквайринговые терминалы и пр.)"<br>
        - техническое обслуживание компьютерной техники, продажа комплектующих<br>
        - продажа и установка антивирусов Kaspersky и DrWeb<br>
        - разработка и сопровождение прикладных программ на языке Python<br>
        <br>
        
        Также наша организация осуществляет продажу CRM-систем, их внедрение и настройку.
        Улучшите взаимодействие с покупателями и упростите выполнение работ сотрудниками с системой управления взаимоотношений с клиентами (CRM)!
        <br>
        <br>
        
        <!--
        Почта: office@ais-center.ru<br>
        Доп. тел. : +79129413168<br>
        +7 (821) 676-33-06<br>
        -->
        <table>
            <tr>
                <td><img alt="Телефон" src="/img/ais/phone.png" width="24"></td>
                <td><strong style="color: blue;">+7 (8216) 76-33-06, +7 (912) 941-31-68</strong></td>
            </tr>
            <tr>
                <td><img alt="E-mail" src="/img/ais/e-mail.png" width="24"></td>
                <td><strong style="color: blue;">office@ais-center.ru</strong></td>
            </tr>
        </table>
        
    </div>
    
    <br>
    <p style="text-align: right; padding-right: 10px;">
        Программы для удалённой поддержки: 
        <a href="/soft/aspia-host-2.7.0-x86_64.exe" title="aspia-host-2.7.0-x86_64" target="_blank" rel="noreferrer">
            Aspia 64bit
        </a>, 
        <a href="/soft/aspia-host-2.7.0-x86.exe" title="aspia-host-2.7.0-x86" target="_blank" rel="noreferrer">
            Aspia 32bit
        </a>, 
        <a href="/soft/AnyDesk.exe" title="AnyDesk" target="_blank" rel="noreferrer">
            AnyDesk
        </a>, 
        <a href="https://github.com/rustdesk/rustdesk/releases" title="RustDesk" target="_blank" rel="noreferrer">
            RustDesk
        </a>
    </p>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    methods: {
        func1: function(){
            alert("+++");
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    
</style>

